export var GET_DASHBOARD_DETAILS = '[Dashboard] Get Dashboard Details';
export var GET_DASHBOARD_DETAILS_SUCCESS = '[Dashboard] Get Dashboard Details Success';
export var GET_DASHBOARD_DETAILS_ERROR = '[Dashboard] Get Dashboard Details Error';
var GetDashboardDetails = /** @class */ (function () {
    function GetDashboardDetails(payload) {
        this.payload = payload;
        this.type = GET_DASHBOARD_DETAILS;
    }
    return GetDashboardDetails;
}());
export { GetDashboardDetails };
var GetDashboardDetailsSuccess = /** @class */ (function () {
    function GetDashboardDetailsSuccess(payload) {
        this.payload = payload;
        this.type = GET_DASHBOARD_DETAILS_SUCCESS;
    }
    return GetDashboardDetailsSuccess;
}());
export { GetDashboardDetailsSuccess };
var GetDashboardDetailsError = /** @class */ (function () {
    function GetDashboardDetailsError(payload) {
        this.payload = payload;
        this.type = GET_DASHBOARD_DETAILS_ERROR;
    }
    return GetDashboardDetailsError;
}());
export { GetDashboardDetailsError };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/store/actions/dashboard.action.ts.pre-build-optimizer.js